export default __webpack_public_path__ + "img/buOJHjZw.8b63368b.svg";